import { render, staticRenderFns } from "./JuniorManage.vue?vue&type=template&id=3b831992&scoped=true"
import script from "./JuniorManage.vue?vue&type=script&lang=js"
export * from "./JuniorManage.vue?vue&type=script&lang=js"
import style0 from "./JuniorManage.vue?vue&type=style&index=0&id=3b831992&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b831992",
  null
  
)

export default component.exports